export const CLONE_IDS = ['base', 'clone1'] as const

export type TCloneId = (typeof CLONE_IDS)[number]

const resolveClone = (cloneId: string | undefined): TCloneId => {
	if (!cloneId) return 'base'

	if (!CLONE_IDS.includes(cloneId as TCloneId)) {
		throw new Error(
			`Unknown CLONE_ID "${cloneId}". Expected one of: ${CLONE_IDS.join(', ')}`,
		)
	}

	return cloneId as TCloneId
}

export const currClone = resolveClone(process.env.CLONE_ID)

export const getVersionForClone = <T>(cloneToModule: Record<TCloneId, T>) =>
	cloneToModule[currClone]

export const getVersionForCloneLazy = <T>(cloneToThunk: Record<TCloneId, () => T>) =>
	cloneToThunk[currClone]()
